import { render, staticRenderFns } from "./flowIndex.vue?vue&type=template&id=1310b9a6&scoped=true&"
import script from "./flowIndex.vue?vue&type=script&lang=js&"
export * from "./flowIndex.vue?vue&type=script&lang=js&"
import style0 from "./flowIndex.vue?vue&type=style&index=0&lang=less&"
import style1 from "./flowIndex.vue?vue&type=style&index=1&id=1310b9a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310b9a6",
  null
  
)

export default component.exports